/* Tame — CTA "Ver todas" da vitrine da home: bolinha vira linha, rótulo em fade.
   Feito 100% em JS (Web Animations API + estilos inline) para não depender da
   cascata de CSS do tema. Usa a classe tame-cta2; o bloco 23 do CSS ficou morto. */
(function () {
  'use strict';
  function init() {
    var btn = document.querySelector('.shopify-section--featured-collections a.button');
    if (!btn || btn.dataset.tameCta) return;
    btn.dataset.tameCta = '1';
    btn.classList.add('tame-cta2');

    var st = btn.style;
    st.setProperty('background', 'transparent', 'important');
    st.setProperty('background-image', 'none', 'important');
    st.setProperty('border', '0', 'important');
    st.setProperty('box-shadow', 'none', 'important');
    st.setProperty('color', '#1c1c1c', 'important');
    st.setProperty('position', 'relative', 'important');
    st.setProperty('overflow', 'visible', 'important');

    var rotulo = document.createElement('span');
    while (btn.firstChild) rotulo.appendChild(btn.firstChild);
    rotulo.style.display = 'inline-block';
    rotulo.style.opacity = '0';
    btn.appendChild(rotulo);

    var linha = document.createElement('span');
    linha.setAttribute('aria-hidden', 'true');
    linha.style.cssText = 'position:absolute;left:50%;bottom:0;transform:translateX(-50%);width:6px;height:6px;border-radius:3px;background:#1c1c1c;opacity:0;pointer-events:none;';
    btn.appendChild(linha);

    var rodou = false;
    function liga() {
      if (rodou) return;
      rodou = true;
      window.removeEventListener('scroll', aoRolar);
      window.removeEventListener('resize', aoRolar);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !linha.animate) {
        linha.style.opacity = '1'; linha.style.width = '100%';
        linha.style.height = '2px'; linha.style.borderRadius = '0';
        rotulo.style.opacity = '1';
        return;
      }
      linha.animate([
        { opacity: 0, width: '6px', height: '6px', borderRadius: '3px', offset: 0 },
        { opacity: 1, width: '6px', height: '6px', borderRadius: '3px', offset: 0.28 },
        { opacity: 1, width: '100%', height: '2px', borderRadius: '0px', offset: 1 }
      ], { duration: 950, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' });
      rotulo.animate([
        { opacity: 0, transform: 'translateY(8px)' },
        { opacity: 1, transform: 'translateY(0px)' }
      ], { duration: 650, delay: 600, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' });
    }
    function confere() {
      if (rodou) return;
      var r = btn.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.88 && r.bottom > 0) liga();
    }
    var esperando = false;
    function aoRolar() {
      if (esperando) return;
      esperando = true;
      requestAnimationFrame(function () { esperando = false; confere(); });
    }
    window.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', aoRolar, { passive: true });
    confere();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
